var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.videoValue.videoClass,on:{"click":_vm.videoOperate}},[_c('svg-icon',{attrs:{"icon":_vm.videoValue.svgIcon,"type":_vm.videoValue.svgType}}),_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.video === "unmuteVideo" ? "关闭摄像头" : "开启摄像头")+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }